import { render, staticRenderFns } from "./MyPivot.vue?vue&type=template&id=355406cf&scoped=true&"
import script from "./MyPivot.vue?vue&type=script&lang=js&"
export * from "./MyPivot.vue?vue&type=script&lang=js&"
import style0 from "./MyPivot.vue?vue&type=style&index=0&id=355406cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355406cf",
  null
  
)

export default component.exports
import {QPage,QTabs,QTab,QBtn,QTabPanels,QTabPanel,QCard,QCardSection,QScrollArea,QInput,QIcon,QSeparator,QExpansionItem,QRadio,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QSlideTransition,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QTabs,QTab,QBtn,QTabPanels,QTabPanel,QCard,QCardSection,QScrollArea,QInput,QIcon,QSeparator,QExpansionItem,QRadio,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QSlideTransition,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
